// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
.intro-interests-module__container____x0Af {
  text-align: center;
}

.intro-interests-module__title___O1M0T {
  font-weight: 500;
  font-size: 1.5rem;
  color: var(--neutral100, #2c2e30);
  margin-bottom: 32px;
  margin-top: 12px;
}

.intro-interests-module__subtitle___jVLgC {
  font-size: 1.125rem;
  color: var(--neutral75, #424547);
}

.intro-interests-module__info___xzAEZ {
  font-size: 1rem;
  color: var(--neutral75, #424547);
  margin-top: 24px;
}

.intro-interests-module__img-container___XCDD9 {
  max-width: 250px;
  margin: 0 auto;
}
.intro-interests-module__img-container___XCDD9 img {
  width: 100%;
  height: auto;
}

.intro-interests-module__button-container___Ure8i {
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
}
.intro-interests-module__button-container___Ure8i button {
  width: -moz-fit-content;
  width: fit-content;
  font-size: 1rem;
}`, "",{"version":3,"sources":["webpack://./node_modules/wa-storybook/styles/tools/functions/_widths.scss","webpack://./client/app/pages/home/components/your-interests/select-interests/intro-interests/intro-interests.module.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACEA;EACE,kBAAA;AAMF;;AAHA;EACE,gBAAA;EACA,iBAAA;EACA,iCAAA;EACA,mBAAA;EACA,gBAAA;AAMF;;AAHA;EACE,mBAAA;EACA,gCAAA;AAMF;;AAHA;EACE,eAAA;EACA,gCAAA;EACA,gBAAA;AAMF;;AAHA;EACE,gBAAA;EACA,cAAA;AAMF;AAJE;EACE,WAAA;EACA,YAAA;AAMJ;;AAFA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AAKF;AAHE;EACE,uBAAA;EAAA,kBAAA;EACA,eAAA;AAKJ","sourcesContent":["/** function to get dimensions\n  usage example to get `tablet` value from `$page-max-widths`\n  .class {\n    max-width: dim($page-max-widths, tablet);\n  }\n\n */\n\n@function dim($prop, $key) {\n  @return map-get($prop, $key);\n}\n","@import '~wa-storybook/styles/utils.scss';\n\n.container {\n  text-align: center;\n}\n\n.title {\n  font-weight: 500;\n  font-size: rem(24);\n  color: color(neutral100);\n  margin-bottom: 32px;\n  margin-top: 12px;\n}\n\n.subtitle {\n  font-size: rem(18);\n  color: color(neutral75);\n}\n\n.info {\n  font-size: rem(16);\n  color: color(neutral75);\n  margin-top: 24px;\n}\n\n.img-container {\n  max-width: 250px;\n  margin: 0 auto;\n\n  img {\n    width: 100%;\n    height: auto;\n  }\n}\n\n.button-container {\n  margin-top: 32px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n\n  button {\n    width: fit-content;\n    font-size: rem(16);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `intro-interests-module__container____x0Af`,
	"title": `intro-interests-module__title___O1M0T`,
	"subtitle": `intro-interests-module__subtitle___jVLgC`,
	"info": `intro-interests-module__info___xzAEZ`,
	"img-container": `intro-interests-module__img-container___XCDD9`,
	"button-container": `intro-interests-module__button-container___Ure8i`
};
export default ___CSS_LOADER_EXPORT___;
